import { render, staticRenderFns } from "./ItineraryCard.vue?vue&type=template&id=04d79015"
import script from "./ItineraryCard.vue?vue&type=script&lang=js"
export * from "./ItineraryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports